import { render, staticRenderFns } from "./setPannel.vue?vue&type=template&id=52c35592"
import script from "./setPannel.vue?vue&type=script&lang=js"
export * from "./setPannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports